const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
tag.async = true;
document.head.appendChild(tag);

const animationSpinning = {
  fadeOut: [
    { opacity: 1 },
    { opacity: 0.5 },
    { opacity: 0 },
  ],
  fadeIn: [
    { opacity: 0 },
    { opacity: 0.5 },
    { opacity: 1 },
  ],
};

const animationTiming = {
  deration: 600,
}

var youtubeData = [
  {
    youtubeId: '8cS_oVDJW1c',
    embedArea: 'ytVideo1',
  }
];

// グローバル関数として定義
window.onYouTubeIframeAPIReady = function() {
  console.log("YouTube API Ready!");
  for (let i = 0; i < youtubeData.length; i++) {
    embedYoutube(i);
  }
};

let ytPlayer;
function embedYoutube(num) {
  ytPlayer = new YT.Player(youtubeData[num]['embedArea'], {
    videoId: youtubeData[num]['youtubeId'],
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerFix,
    },
    playerVars: {
      autoplay: 0,
      rel: 0,
      playlist: youtubeData[num]['youtubeId'],
    },
  });
}

function onPlayerReady(event) {
  const playBtn = event.target.g.closest('.pg-mov').querySelector('.js-yt-playbtn');
  playBtn.addEventListener('click', () => {
    playBtn.animate(animationSpinning.fadeOut, animationTiming.deration);
    if (playBtn.style.display === 'block' || playBtn.style.display === '') {
      setTimeout(() => {
        playBtn.style.display = 'none';
      }, animationTiming.deration);
    }

    event.target.mute();
    event.target.playVideo();
  });
}

function onPlayerFix(event) {
  const playBtn = event.target.g.closest('.pg-mov').querySelector('.js-yt-playbtn');
  if (event.data === YT.PlayerState.ENDED) {
    event.target.seekTo(0, true);
    event.target.stopVideo();
    if (playBtn.style.display === 'none') {
      playBtn.animate(animationSpinning.fadeIn, animationTiming.deration);
      playBtn.style.display = 'block';
    }
  }
}

($ => {
  window.addEventListener('scroll', function() {
    scrollAddClass('.js-scroll-class');
  })

  // scroll class追加
  function scrollAddClass(selector) {
    const _default = {
      startDelay: 0.25,
      mode: 'default'
    };

    let allElem = $.querySelectorAll(selector);
    const settings = { ..._default };

    [...allElem].map((elem, i) => {
      let offsetTop = elem.getBoundingClientRect().top + window.scrollY;
      const startDelay = elem.dataset.startDelay || settings.startDelay;
      if ((window.scrollY + window.innerHeight) - (window.innerHeight * startDelay) >= offsetTop) {
        if (!elem.classList.contains('is-animated')) {
          elem.classList.add('is-animated');
          elem.dispatchEvent(new Event('classAdded'));
        }
      } else {
        if (settings.mode === 'alternate') elem.classList.remove('is-animated');
      }
    });
  }
})(document);
